import JoinUs from '../sections/join-us/JoinUs';
import App from '../App';

window.App = App;
window.Section = JoinUs;


